import tp from 'shared-tokens/utils/tokens/typography';
import spacings from 'shared-tokens/utils/tokens/spacings';
import createBreakpoint from 'shared-tokens/utils/breakpoints';

import getExtPath from 'shared-utils/src/getExtPath';

const brpS = createBreakpoint('s');

export const mainCls = 'usrlogin';

const socialLogoDefaults = {
  display: 'inline-block',
  width: '20px',
  height: '20px',
};
const dottedSeparator = {
  content: '""',
  position: 'absolute',
  left: 0,
  width: '100%',
  height: 1,
  backgroundImage: 'linear-gradient(90deg, #96a1b0 20%, rgba(255, 255, 255, 0) 0)',
  backgroundPosition: '0',
  backgroundSize: '4px 1px',
  backgroundRepeat: 'repeat-x',
};

export default {
  [mainCls]: {
    width: '100%',
    maxWidth: '540px',
  },
  [`${mainCls}__loginunrgstrd`]: {
    background: '#fff',
    '&__forgot': {
      textAlign: 'center',

      '&_link': {
        textDecoration: 'underline',
        color: '#505A65',
      }
    },
    '&__login_btn': {
      width: '240px',
    }
  },
  [`${mainCls}__social__btns_cnt`]: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  [`${mainCls}__social__social_btn`]: {
    width: '240px',
    padding: '0 20px',
    fontSize: '15px !important',
  },
  
  [`${mainCls}__social__a`]: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    [brpS]: {
      fontSize: tp.tpSizes.xs,
      lineHeight: `${spacings.l}px!important`,
    },
    '&:last-of-type': {
      marginBottom: '0!important',
    },
  },
  [`${mainCls}__social__a--apple`]: {
    'backgroundColor': '#1a1f24',
    '&:hover': {
      backgroundColor: '#000',
    },
    '& .logo': {
      ...socialLogoDefaults,
      background: `url(${getExtPath('loginIcons/apple.svg')}) center center no-repeat`,
    },
  },
  [`${mainCls}__social__a--fb`]: {
    'backgroundColor': '#3b5998',
    '&:hover': {
      backgroundColor: '#2e467c',
    },
    '& .logo': {
      ...socialLogoDefaults,
      background: `url(${getExtPath('loginIcons/facebook.svg')}) center center no-repeat`,
    },
  },
  [`${mainCls}__social__a--google`]: {
    'color': '#505a65!important',
    'background': '#fff',
    'borderColor': '#96a1b0!important',
    '&:hover': {
      borderColor: '#333F48!important',
    },
    '& .logo': {
      ...socialLogoDefaults,
      background: `url(${getExtPath('loginIcons/google.svg')}) center center no-repeat`,
    },
  },
  [`${mainCls}__mycasa__else`]: {
    'position': 'relative',
    'lineHeight': '66px',
    '&::before': {
      ...dottedSeparator,
      top: '50%',
    },
  },
  [`${mainCls}__mycasa__else--txt`]: {
    display: 'block',
    position: 'relative',
    zIndex: '1',
    margin: '0 auto',
    width: '70px',
    color: '#505a65',
    background: '#f0f2f5',
  },
  [`${mainCls}__mycasa__input`]: {
    'margin': `0 0 ${spacings.s}px`,
    '&:last-of-type': {
      marginBottom: spacings.m,
    },
  },
  [`${mainCls}__mycasa__loginerror`]: {
    color: '#ff8000',
    lineHeight: '20px',
  },
  [`${mainCls}__mycasa__forgot`]: {
    padding: '16px 0 24px 0',
  },
  [`${mainCls}__more`]: {
    'position': 'relative',
    'lineHeight': '69px',
    '&::before': {
      ...dottedSeparator,
      top: 0,
    },
  },
  [`${mainCls}__alredyEmailAndPsw`]: {
    textAlign: 'center',
  },
  [`${mainCls}__confirm_email_link`]: {
    textDecoration: 'underline',
    cursor: 'pointer',
  },
  [`${mainCls}__account_link_cnt`]: {
    textAlign: 'center',
  },
  [`${mainCls}__expand_btn`]: {
    backgroundColor: '#fff !important',
    color: '#505A65 !important'
  },
  
  [`${mainCls}__form_cnt`]: {
    width: '100%',
  },
};
